import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input, InputNumber,
  message,
  Popconfirm,
  Row,
  Select,
  Spin,
  Table
} from 'antd';
import React from 'react';
import { sanitizeFieldName } from '../../util/methods';
import DocumentList from '../../components/DocumentList';
import moment from 'moment';
import MasterModal from "../../components/MasterModal";
import Descriptions from "antd/lib/descriptions";
import { stringify } from "query-string";

let count = 0;
const { TextArea } = Input;
let readings = [], meter = [], meterUnit = [];
let ataSelected = false;

class Create extends React.Component {

  state = {
    showCancelButton: false,
    tableData: [],
    documentData: [],
    meter: [],
    meterUnit: [],
  };

  componentDidMount() {
    const { match, fetch } = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };

  cancelAta = (e) => {
    e.preventDefault();
    this.props.cancelAta({ ata: this.props.form.getFieldValue('ata') });
  };

  handleAtaSelect() {
    count = 0;
    this.setState({ showCancelButton: true });
  };

  handleSubmit = (e) => {
    const { match } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const { documentData } = this.state;
      const data = Object.assign({}, values);
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData;
      }
      data.dependentAssets = [];
      if (this.props.title === 'CREATE') {
        for (let k = 0; k < data.assets.length; k++) {
          let ast = data.assets[k];
          let asset = this.state.tableData.find(item => stringify(item.key) === stringify(ast));
          if (asset && asset.children && asset.children.length) {
            for (let l = 0; l < asset.children.length; l++) {
              data.dependentAssets.push({
                parentAsset: asset.key,
                subAsset: asset.children[l].key
              });
            }
          }
        }
      } else {
        for (let k = 0; k < this.state.tableData.length; k++) {
          let asset = this.state.tableData[k];
          if (asset && asset.children && asset.children.length) {
            for (let l = 0; l < asset.children.length; l++) {
              data.dependentAssets.push({
                parentAsset: asset.key,
                subAsset: asset.children[l].key
              });
            }
          }
        }
      }

      for (let i = 0; i < meter.length; i++) {
        if (!meter[i]) {
          meter[i] = {};
        }
      }

      for (let i = 0; i < meterUnit.length; i++) {
        if (!meterUnit[i]) {
          meterUnit[i] = {};
        }
      }

      readings = [];
      if (this.state.tableData && this.state.tableData.length && this.state.meterUnit && this.state.meter && this.state.meter.length && this.state.meterUnit.length) {
        for (let i = 0; i < this.state.tableData.length; i++) {
          let meterFound = meter.find(element => stringify(element.asset) === stringify(this.state.tableData[i].key));
          let meterUnitFound = meterUnit.find(element => stringify(element.asset) === stringify(this.state.tableData[i].key));
          if (meterFound && meterUnitFound) {
            readings.push({
              asset: this.state.tableData[i].key,
              meter: meterFound.meter || 0,
              meterUnit: meterUnitFound.meterUnit
            });
          }
        }
        data.readings = readings;
      } else {
        data.readings = [];
      }
      data.grnDate = moment(data.grnDate)
      data.receivedBy = {
        name: data.receivedBy.name,
        date: moment(data.receivedBy.date)
      }
      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    }
    );
  };


  handleMeter = (e, assetId, index) => {
    if (e && e.target) {
      if (Number(e.target.value) < 0) {
        return message.error('Meter reading can not be negative!');
      }
      let obj = {};
      meter = this.state.meter;
      obj = { asset: assetId, meter: e.target.value || 0 };
      meter[index] = {};
      Object.assign(meter[index], obj);
      this.setState({ meter: meter });
    }
  }

  handleUnitSelect = (value, assetId, index) => {
    let obj = {};
    meterUnit = this.state.meterUnit;
    obj = { meterUnit: value, asset: assetId };
    meterUnit[index] = {};
    Object.assign(meterUnit[index], obj);
    this.setState({ meterUnit: meterUnit });
  }

  fetchMeterUnit = (values) => {
    this.props.fetchMeterUnit(values);
  };

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.data && (JSON.stringify(nextProps.data.assets) !== JSON.stringify(this.props.assets))) {
      const assetData = nextProps.data.assets;
      const arr = assetData.map(item => {
        return {
          key: item._id,
          assetCode: item.assetCode,
          rate: item.rate,
          description: item.description,
          checkbox: item,
          meter: item.meter || 0,
          meterUnit: item.meterUnit,
        }
      });

      for (let i = 0; i < arr.length; i++) {
        let asset = arr[i];
        asset.children = [];
        for (let j = 0; j < nextProps.data.dependentAssets.length; j++) {
          let sAsset = nextProps.data.dependentAssets[j].subAsset;
          if (stringify(asset.key) === stringify(nextProps.data.dependentAssets[j].parentAsset)) {
            asset.children.push({
              key: sAsset._id,
              assetCode: sAsset.assetCode,
              description: sAsset.description || `Dependent Asset of ${asset.assetCode}`,
              subAsset: true,
            });
          }
        }
      }

      if (meter.length === 0 && meterUnit.length === 0) {
        for (let i = 0; i < arr.length; i++) {
          meterUnit[i] = {};
          meter[i] = {};
          meter[i] = { asset: arr[i].key, meter: arr[i].meter || 0 };
          meterUnit[i] = { meterUnit: arr[i].meterUnit, asset: arr[i].key };
        }
      }
      this.setState({ tableData: arr, meter: meter, meterUnit: meterUnit });
    }
    if (nextProps.assetListByAta && JSON.stringify(nextProps.assetListByAta.assets) !== JSON.stringify(this.props.assetListByAta.assets)) {
      const assetData = nextProps.assetListByAta.assets;
      const arr = assetData.map(item => {
        return {
          key: item._id,
          assetCode: item.assetCode,
          rate: item.rate,
          description: item.description,
          checkbox: item,
        }
      });

      for (let i = 0; i < arr.length; i++) {
        let asset = arr[i];
        asset.children = [];
        for (let j = 0; j < nextProps.assetListByAta.dependentAssets.length; j++) {
          let sAsset = nextProps.assetListByAta.dependentAssets[j].subAsset;
          if (stringify(asset.key) === stringify(nextProps.assetListByAta.dependentAssets[j].parentAsset)) {
            asset.children.push({
              key: sAsset._id,
              assetCode: sAsset.assetCode,
              description: sAsset.description || `Dependent Asset of ${asset.assetCode}`,
              subAsset: true,
            });
          }
        }
      }
      this.setState({ tableData: arr });
    }
  }

  assetTable() {
    const { data, title, assetListByAta } = this.props;
    const { tableData } = this.state;
    if (tableData && tableData.length) {
      count = tableData.length;
    }
    const columns = [
      {
        title: 'Asset Code',
        dataIndex: 'assetCode',
        key: 'assetCode',
      },
      // {
      //   title: 'Rate',
      //   dataIndex: 'rate',
      //   key: 'rate',
      // },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Select',
        dataIndex: 'checkbox',
        key: 'checkbox',
        align: 'center',
        render: (item, record) => record && !record.subAsset && <Checkbox key={item._id} value={item._id}> </Checkbox>,
      },
      {
        title: 'Meter',
        dataIndex: 'meter',
        key: 'meter',
        align: 'center',
        render: (item, record, index) => record && !record.subAsset &&
          <input type={'number'} key={record.key} placeholder={'Meter Value'}
            onChange={(e, ind) => {
              this.handleMeter(e, record.key, index)
            }}
            style={{ width: '45%', height: '37px', borderRadius: '7px', paddingLeft: '12px' }}
            disabled={this.props && this.props.title && this.props.title === 'VIEW'}
            value={this.props && this.props.title && this.props.title === 'EDIT' ? this.state.meter[index].meter :
              this.props.title === 'VIEW' ? (record && record.meter) : (this.state.meter && this.state.meter[index] && this.state.meter[index].meter) || ''} />
      },
      {
        title: 'Meter Unit',
        dataIndex: 'meterUnit',
        key: 'meterUnit',
        align: 'center',
        render: (item, record, index) =>
          record && !record.subAsset && <Select
            value={(this.props && this.props.title && this.props.title === 'VIEW') ? record && record.meterUnit :
              (this.state.meterUnit && this.state.meterUnit[index] && this.state.meterUnit[index].meterUnit) || 'Search Unit'}
            key={record.key}
            style={{ width: '85%', height: '40px', borderColor: 'black !important' }}
            disabled={this.props && this.props.title && this.props.title === 'VIEW'}
            showSearch={true}
            showArrow={false}
            allowClear={false}
            onSearch={this.fetchMeterUnit}
            onSelect={(e, recordId, ind) => {
              this.handleUnitSelect(e, record.key, index)
            }}
            mode="single"
            placeholder={`Search Unit`}
          >{
              this.props && this.props.meterUnit && this.props.meterUnit.data && this.props.meterUnit.data.map((item) => {
                return <Select.Option key={item._id} value={item.name}>{item['name']}</Select.Option>
              })
            }
          </Select>,
      },
    ];
    return <Table columns={columns} dataSource={tableData} pagination={false} onRowClick={this.rowSelection} />
  }

  // rowSelection objects indicates the need for row selection
  rowSelection = (record) => {
    const url = `/asset/history-report/${record.key}`;
    if (record && record.subAsset) {
      window.open(url);
    }
  };

  componentWillUnmount() {
    readings = [];
    meter = [];
    meterUnit = [];
    this.props.clearArnData();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, loading, filters, title, resource, form } = this.props;
    const { showCancelButton } = this.state;
    let openAtaData = [];
    openAtaData = filters['ata'] && filters['ata']['data'] && filters['ata']['data']['data'].filter(item => {
      return item.ataStatus === 'Open';
    });

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} type="flex" align="bottom">
              <Col span={12}>
                {(filters['receiptStatus'] && title === 'CREATE') ? null : title === 'EDIT' && filters['receiptStatus'] &&
                  <Form.Item key={'receiptStatus'} label={'Receipt Status'}>
                    {getFieldDecorator('receiptStatus', {
                      initialValue: data && data.receiptStatus,
                    })(<Input disabled />)
                    }
                  </Form.Item>
                }

                <Form.Item key={'ata'} label={'Select ATA'}>
                  {getFieldDecorator('ata', {
                    rules: [{ required: true, message: `ATA is required!` }],
                    initialValue: data && data.ata && data.ata.ataNo,
                  })(
                    <Select
                      showSearch
                      style={{ width: '100%' }}
                      placeholder="Select ATA"
                      onFocus={() => {
                        ataSelected = true;
                      }}
                      filterOption={(input, option) =>
                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                      }
                      onChange={this.handleAtaSelect.bind(this)}
                      onSelect={this.props.fetchAssetListByAta}
                      disabled={((title === 'EDIT' || title === 'VIEW') && filters['ata'] && filters['ata'].options.disabledOnEdit) || false}
                    >
                      {openAtaData && openAtaData.map(item =>
                        <Select.Option key={item._id} value={item._id}>{item.ataNo}</Select.Option>)}
                    </Select>)}
                </Form.Item>
              </Col>
              {
                title === 'CREATE' && showCancelButton && <Col span={12} style={{ paddingBottom: '12px' }}>
                  <Popconfirm
                    title="Are you sure you want to cancel this record?"
                    onConfirm={this.cancelAta}
                    onCancel={() => {
                      message.error('Cancelled')
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="primary" className="gx-mb-0" htmlType={'button'} loading={loading}>CANCEL ATA</Button>
                  </Popconfirm>

                </Col>
              }
            </Row>

            {
              (title === 'EDIT' || title === 'VIEW') && <Form.Item key={'arnNo'} label={'ARN Number'}>
                {getFieldDecorator('arnNo', {
                  rules: [{ required: false, message: `ARN Number is required!` }],
                  initialValue: ((data && data.arnNo) || '')
                })(<Input disabled />)
                }
              </Form.Item>
            }

            <Form.Item key={'assets'} label={'Assets'}>
              {getFieldDecorator('assets', {
                rules: [{ required: true, message: `Assets is required!` }],
                initialValue: (data && data.assets && data.assets.length) ? data.assets.map(field => field._id) : [],
              })(<Checkbox.Group style={{ width: '100%' }}
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['assets'] && filters['assets'].options.disabledOnEdit) || false}>
                {this.assetTable()}
              </Checkbox.Group>)
              }
            </Form.Item>

            <Descriptions bordered title="">
              <Descriptions.Item
                label="Asset Count"> {title === 'CREATE' ? (count || 0) : (data && data.assets && data.assets.length) ?
                  data.assets.length : 0}</Descriptions.Item>
            </Descriptions>

            <Form.Item key={'grnDate'} label={'GRN Date'} style={{ marginTop: '15px' }}>
              {getFieldDecorator('grnDate', {
                rules: [{ required: true, message: `GRN Date is required!` }],
                initialValue: data && data.grnDate && moment(data.grnDate),
              })(<DatePicker
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['grnDate'] && filters['grnDate'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'grnNo'} label={'Manual GRN Number'}>
              {getFieldDecorator('grnNo', {
                rules: [{ required: true, message: `Manual GRN Number is required!` }],
                initialValue: data && data.grnNo,
              })(<Input
                disabled={((title === 'EDIT' || title === 'VIEW') && filters['grnNo'] && filters['grnNo'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'otherCost'} label={'Other Cost'}>
              {getFieldDecorator('otherCost', {
                rules: [{ required: false, message: `Other Cost is required!` }],
                initialValue: data && data.otherCost,
              })(<Input type='number'
                onWheel={event => event.currentTarget.blur()}
                placeholder={'Other Cost'}
                style={{ marginRight: 8 }}
                disabled={(title === 'VIEW' && filters['otherCost'] && filters['otherCost'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Form.Item key={'otherCostDetails'} label={'Other Cost Details'}>
              {getFieldDecorator('otherCostDetails', {
                rules: [{ required: false, message: `Other Cost Details is required!` }],
                initialValue: data && data.otherCostDetails,
              })(<Input placeholder={'Other Cost Details'}
                disabled={(title === 'VIEW' && filters['otherCostDetails'] && filters['otherCostDetails'].options.disabledOnEdit) || false} />)
              }
            </Form.Item>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item key={'receivedBy.date'} label={'Received By Date'}>
                  {getFieldDecorator('receivedBy.date', {
                    rules: [{ required: true, message: `Received By Date is required!` }],
                    initialValue: data && data.receivedBy && data.receivedBy.date && moment(data.receivedBy.date),
                  })(<DatePicker showTime style={{ width: '100%' }}
                    disabled={((title === 'EDIT' || title === 'VIEW') && filters['receivedBy.date'] && filters['receivedBy.date'].options.disabledOnEdit) || false} />)}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item key={'receivedBy.name'} label={'Received By Name'}>
                  {getFieldDecorator('receivedBy.name', {
                    rules: [{ required: true, message: `Received By Name is required!` }],
                    initialValue: data && data.receivedBy && data.receivedBy.name && data.receivedBy.name._id,
                  })(<Select
                    showSearch
                    style={{ width: '80%' }}
                    placeholder="Please select"
                    filterOption={(input, option) =>
                      (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                    }
                    disabled={(title === 'VIEW' ? true : title === 'EDIT' && filters['receivedBy.name'] && filters['receivedBy.name'].options.disabledOnEdit) || false}
                  >
                    {filters['receivedBy.name'] && filters['receivedBy.name']['data'] && filters['receivedBy.name']['data']['data'].map(item =>
                      <Select.Option key={item._id} value={item._id}>{item.name}</Select.Option>)}
                  </Select>)}
                  {
                    filters['receivedBy.name'] && filters['receivedBy.name'].options && filters['receivedBy.name'].options.master && this.props.title !== 'VIEW' ?
                      <MasterModal resource={resource} item={filters['receivedBy.name'].options.ref}
                        title={'CREATE'} /> : ''
                  }
                </Form.Item>
              </Col>
            </Row>

            <Form.Item key={'remarks'} label={'Remarks'}>
              {getFieldDecorator('remarks', { initialValue: data && data.remarks })(<TextArea
                disabled={this.props.title && this.props.title === 'VIEW'} rows={3} />)}
            </Form.Item>

            {filters && filters.documents &&
              <DocumentList history={this.props.history} match={this.props.match} key={filters.documents}
                item={filters.documents} form={form} data={data.documents}
                getDocumentData={this.getDocumentData} title={title}
                isDisabled={(title === 'VIEW' ? true : filters['documents'] && filters['documents'].options.disabledOnEdit) || false} />}

            <Form.Item>
              {this.props.title === 'VIEW' ? '' :
                <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}
                  disabled={title === 'VIEW' || false}>
                  {title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                </Button>}
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
